import React, { Component, lazy, Suspense } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { fetchDashboardList, fetchSystemWidgetsList } from "../../../actions/dashboardAction";
import SubscriptionRoute from "../../SubscriptionModule/SubscriptionRoute";
import DashboardContentPage from "./DashboardContentPage";

import Loader from "../../Loader/Loader";

const LoadableDashboard = lazy(() => import("./DashboardContainer"));
const LoadableCreateDashboard = lazy(() => import("./CreateDashboardContainer"));

class DashboardRoute extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // this.props.fetchDashboardList();
        this.props.fetchSystemWidgetsList();
    }

    render() {
        return (
            <Suspense fallback={<Loader />}>
                <Switch>
                    <Route
                        path={[
                            "/dashboard/all/:id",
                            "/dashboard/my/:id",
                            "/dashboard/shared/:id",
                            "/dashboard/standard/:id",
                            "/dashboard/favorites/:id",
                            "/dashboard/recent/:id",
                            "/dashboard/commandcenter/:id",
                            "/dashboard/drafts/:id",
                            "/dashboard/temporary/:id",
                        ]}
                        render={(props) => <DashboardContentPage {...props} />}
                    />
                    <SubscriptionRoute path="/dashboard/createdashboard" render={(props) => <LoadableCreateDashboard {...props} />} />
                    <Route path="/dashboard" render={(props) => <LoadableDashboard {...props} />} />
                </Switch>
            </Suspense>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchDashboardList: () => dispatch(fetchDashboardList()),
        fetchSystemWidgetsList: () => dispatch(fetchSystemWidgetsList()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardRoute);
